
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmailDetailHeaderProps {
  folder: string | undefined;
}

export const EmailDetailHeader = ({ folder }: EmailDetailHeaderProps) => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="border-b p-4 flex items-center bg-card">
      <Button variant="ghost" size="sm" onClick={handleBack}>
        <ArrowLeft className="h-4 w-4 mr-2" />
        Back to {folder || 'inbox'}
      </Button>
    </div>
  );
};
